import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-salones',
  templateUrl: './salones.component.html',
  styleUrls: ['./salones.component.css']
})
export class SalonesComponent implements OnInit {


  constructor() {
  }

  ngOnInit() {
  }

}
